import { makeAutoObservable } from 'mobx';
import { ColorEnum, IconNameEnum } from '@app/common';
import { WatchlistDto, WatchlistListDto } from '../../../../defs/api';
import { ensureColorName, ensureIconName } from '../../../../utils/ensure-enum-value';

type WatchlistSourceDto = WatchlistDto | WatchlistListDto;

export class WatchlistMobxDto implements Omit<WatchlistDto, 'iconName' | 'colorName'> {
    id: string = '';

    name: string = '';

    iconName: IconNameEnum = IconNameEnum.WalletFilled;

    colorName: ColorEnum = ColorEnum.Blue;

    userId: string = '';

    constructor() {
        makeAutoObservable(this, {});
    }

    static create(dto: WatchlistSourceDto): WatchlistMobxDto {
        const mobxDto = new WatchlistMobxDto();

        Object.assign(mobxDto, dto);

        mobxDto.iconName = ensureIconName(dto.iconName);
        mobxDto.colorName = ensureColorName(dto.colorName);

        return mobxDto;
    }

    static createFromArray(dtos: WatchlistSourceDto[]): WatchlistMobxDto[] {
        return dtos.map((dto) => WatchlistMobxDto.create(dto));
    }
}
